

import React, { createContext, useContext, useEffect, useReducer } from 'react'
import reducer from './reducer';

const initialState = {
  contextLoading: true, // Se pone en falso cuando el conexto se ha actualizado con las variables minimamente requeridas 
  currentUser: null,    // Mantiene los datos del usuario logeado
  openLogin: false,     // Variable para abrir desde distintos lugares el dialogo de LogIn
  profile: {open: false, file: null, photoUrl: ''},   // Variable/Objeto para gestionar el dialogo de Profile
  okCancelDialog: { open: false, title: '', message: '', repuesta: '', callerData: null}, //Dialogo para confirmar una acción
  loading: false,       // Para mostar o no el gráfico de "Loading"
  alert: { open: false, severity: 'info', message: '' },
  drawerState: false,   //mantiene el estado del drawer, abierto o cerrado
  marcas: [],           // Array para guardar todas las marcas recibidas desde la base de datos
  users: [],            // Usuarios
  productos: [],        // Productos
  categorias: [],       // Categoria de productos
  proveedores: [],      // Array que guarda todos los proveedores
}

const Context = createContext(initialState);

export const useValue = () => {
  return useContext(Context);
}


const ContextProvider = ({ children }) => {

  const [state, dispatch] = useReducer(reducer, initialState);

  const { contextLoading } = state;  

  /*  En el primer renderizado se busca si se tiene algún usuario ya logueado, para no solicitar nuevamente se loguee
      cada vez que entra a la página */
  useEffect(() =>{
    const currentUserSaved = JSON.parse(localStorage.getItem('currentUser'));
    if(currentUserSaved) {
      dispatch({type: 'UPDATE_USER', payload: currentUserSaved})
    }
    dispatch({type: 'CLEAR_CONTEXT_LOADING'});  //actualiza la variable contextLoading a false para indicar que se actualizaron los datos minimamente necesarios
  },[]);

  return (
    <Context.Provider value={{ state, dispatch }}>
      {children}
    </Context.Provider>
  )
}

export default ContextProvider